import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';

import { API } from '@/config';

export default function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!token) {
      setError('No verification token provided.');
      return;
    }
    axios.get(`${API}/auth/verify?token=${token}`)
      .then(() => {
        toast.success('Email verified! You can now sign in.');
        navigate('/login', { replace: true });
      })
      .catch(err => {
        const detail = err.response?.data?.detail || 'Verification failed.';
        if (detail.includes('already verified')) {
          toast.info('Email already verified.');
          navigate('/login', { replace: true });
        } else {
          setError(detail);
        }
      });
  }, [token, navigate]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background px-4">
        <div className="w-full max-w-sm text-center">
          <p className="text-sm text-destructive mb-4">{error}</p>
          <a href="/signup" className="text-sm text-[#10B981] hover:underline">Sign up again</a>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <Loader2 className="h-8 w-8 text-[#10B981] animate-spin" />
    </div>
  );
}
